import {useCallback, useRef} from 'react'
import {useMappedState} from 'redux-react-hook'

function useAggTrades (symbol) {
  const timeRef = useRef()
  const resultRef = useRef([])
  const mapState = useCallback(state => state?.aggTrades?.[symbol] || [], [symbol])
  const aggTrades = useMappedState(mapState)
  const now = Date.now()
  if (resultRef.current.length > 0 && timeRef.current && now - timeRef.current < 500) {
    return resultRef.current
  }
  timeRef.current = now
  resultRef.current = aggTrades
  return aggTrades?.sort((a, b) => b.tradeTime - a.tradeTime)
}

export default useAggTrades
